<template>
    <div :class="{expanded:show_menu, collapsed: !show_menu, 'site-menu':true}">
        <!-- empty placeholder -->
    </div>
    <div :class="{expanded:show_menu, collapsed: !show_menu, 'site-menu':true}" style='position:fixed' @click='expand'>
        <div style='height: 128px;'>
            <!-- main menu button placeholder -->
        </div>
        <ul class="navigationx" style='display:flex;flex-direction:column; height: calc(100% - 130px);'>
            <div style='flex: 1'>
                <div class='custom-menu'>
                    <slot></slot>
                </div>

                <hr/>

                <div class='standard-menu'>
                    <div class='menu-group' v-if="data?.viewingUser?.admin">
                        <button class='menu-header' @click='clickMenuGroup("create-new")'>
                            <div>
                                <img src="/static/images/redisign/icons-left-menu/icon-create-all.png" alt="menu icon" style="width: 24px; margin-right: 12px;">{{$t("Create")}}
                            </div>  
                        </button>                            
                        <div v-show='tab == "create-new"'>
                            <div style="padding: 8px 0;background: #333335;">
                                <a class='menu-item' href='/lk/create-new/challenge' data-href='/lk/create-new/challenge'>{{$t("Game")}}</a>
                                <!--<a class='menu-item' href='/lk/create-new/template-challenge' data-href='/lk/create-new/template-challenge'>{{$t("Game from template")}}</a>-->
                                <a class='menu-item' href='/lk/create-new/task' data-href='/lk/create-new/task'>{{$t("Task")}}</a>
                                <template v-if="data?.viewingUser?.admin">
                                    <a class='menu-item' href='/lk/create-new/deck' data-href='/lk/create-new/deck'>{{$t("Card deck")}}</a>
                                    <a class='menu-item' href='/lk/create-new/course' data-href='/lk/create-new/course'>{{$t("Course")}}</a>    
                                    <!--<a class='menu-item' href='/lk/create-new/ai-challenge' data-href='/lk/create-new/ai-challenge'>{{$t("Generate game")}}</a>  -->  
                                </template>
                            </div> 
                        </div>
                    </div>
                    <div class='menu-group'>
                        <button class='menu-header' @click='clickMenuGroup("catalog")'>
                            <div>
                                <img src="/static/images/redisign/icons-left-menu/icon-infinity.png" alt="menu icon" style="width: 24px; margin-right: 12px;">{{$t("Catalog")}}    
                            </div>  
                        </button>                            
                        <div v-show='tab == "catalog"'>
                            <div style="padding: 8px 0;background: #333335;">
                                <a class='menu-item' href='/catalog/skillsets' data-href='/catalog/skillsets'>{{$t("Skillsets")}}</a>
                                <a class='menu-item' href='/catalog/courses' data-href='/catalog/courses'>{{$t("Courses")}}</a>
                                <a class='menu-item' href='/catalog/challenges' data-href='/catalog/challenges'>{{$t("Challenges")}}</a>
                                <a class='menu-item' href='/catalog/tasks' data-href='/catalog/tasks'>{{$t("Games")}}</a>
                                <a class='menu-item' href='/catalog/cardlists' data-href='/catalog/cardlists'>{{$t("Study decks")}}</a>    
                            </div> 
                        </div>
                    </div>
                    <div class='menu-group'>
                        <button class='menu-header' @click='clickMenuGroup("imstudy")'>
                            <div>
                                <img src="/static/images/redisign/icons-left-menu/icon-i-learningl.png" alt="menu icon" style="width: 24px; margin-right: 12px;">
                                <span class=''>{{$t("I'm study")}}</span>
                                <span v-if='data.viewingUser?.dueSkillCount>0' class='labelDue badge rounded-pill bg-success'>{{data.viewingUser.dueSkillCount}}</span>    
                            </div> 
                        </button>
                        <div v-show='tab == "imstudy"'>
                            <div style="padding: 8px 0;background: #333335;">
                                <a class='menu-item' href='/lk/coursesIStudy' data-href='/lk/coursesIStudy'>{{$t("Courses")}}</a>
                                <a class='menu-item' href='/lk/userCardLists' data-href='/lk/userCardLists'>
                                    <span class=''>{{$t("Study decks")}}</span>
                                    <span v-if='data.viewingUser?.dueSkillCount>0' class='labelDue badge rounded-pill bg-success'>{{data.viewingUser.dueSkillCount}}</span>
                                </a>
                                <a class='menu-item authorize' href='/profile' data-href='/profile'>
                                    {{$t("My skills")}}
                                </a>
                            </div>    
                        </div>
                    </div>
                    <div class='menu-group'>
                        <button class='menu-header' @click='clickMenuGroup("my-content")'>
                            <div>
                                <img src="/static/images/redisign/icons-left-menu/icon-my-content.png" alt="menu icon" style="width: 24px; margin-right: 12px;">{{$t("My Content")}}    
                            </div>  
                        </button>
                        <div v-show='tab == "my-content"'>
                            <div style="padding: 8px 0;background: #333335;">
                                <a class='menu-item' href='/lk/mySkillsets' data-href='/lk/mySkillsets'>{{$t("Skillsets")}}</a>
                                <a class='menu-item' href='/lk/cardLists' data-href='/lk/cardLists'>{{$t("Study decks")}}</a>
                                <a class='menu-item' href='/lk/myCourses' data-href='/lk/myCourses'>{{$t("Courses")}}</a>
                                <a class='menu-item' href='/lk/myGames' data-href='/lk/myGames'>{{$t("Challenges")}}</a>
                                <a class='menu-item' href='/lk/myTasks' data-href='/lk/myTasks'>{{$t("Games")}}</a>
                                <!-- <a class='menu-item' href='/lk/fieldSets' data-href='/lk/fieldSets'>{{$t("Field Sets")}}</a>
                                <a class='menu-item' href='/lk/cardTemplates' data-href='/lk/cardTemplates'>{{$t("Card Templates")}}</a> -->
                                <!-- <a class='menu-item' href='/lk/cards' data-href='/lk/cards'>Cards</a> -->
                            </div> 
                        </div>
                    </div>
                    <div class='menu-group'>
                        <button class='menu-header' @click='clickMenuGroup("for-game-authors")'>
                            <div>
                                <img src="/static/images/redisign/icons-left-menu/icon-left-menu-authors.png" alt="menu icon" style="width: 24px; margin-right: 12px;">{{$t("for-game-authors")}}
                            </div>  
                        </button>
                        <div v-show='tab == "for-game-authors"'>
                            <div style="padding: 8px 0;background: #333335;">
                                <a class='menu-item' href='/lk/createTask' data-href='/lk/createTask'>{{$t("createTask")}}</a> 
                                <a class='menu-item' href='/lk/createGame' data-href='/lk/createGame'>{{$t("createGame")}}</a>
                                <a class='menu-item' href='/lk/howToPlay' data-href='/lk/howToPlay'>{{$t("howToPlay")}}</a>
                                <a class='menu-item' href='/lk/playWithFriends' data-href='/lk/playWithFriends'>{{$t("playWithFriends")}}</a>
                                <a class='menu-item' href='/lk/teamPlay' data-href='/lk/teamPlay'>{{$t("teamPlay")}}</a>  
                            </div> 
                        </div>
                    </div>
                    <div class='menu-group' v-if="data?.viewingUser?.admin">
                        <button class='menu-header' @click='clickMenuGroup("about-events")'>
                            <div>
                                <img src="/static/images/redisign/icons-left-menu/icon-left-menu-events.png" alt="menu icon" style="width: 24px; margin-right: 12px;">{{$t("about-events")}}
                            </div>  
                        </button>
                        <div v-show='tab == "about-events"'>
                            <div style="padding: 8px 0;background: #333335;">
                                <!--<a class='menu-item' href='/lk/howToOrganize' data-href='/lk/howToOrganize'>{{$t("howToOrganize")}}</a>-->
                                <a class='menu-item' href='/lk/activityExamples' data-href='/lk/activityExamples'>{{$t("activityExamples")}}</a>
                                <a class='menu-item' href='/lk/orderActivity' data-href='/lk/orderActivity'>{{$t("orderActivity")}}</a>   
                            </div> 
                        </div>
                    </div>

                    <div class='menu-group'>
                        <button class='menu-header' @click='clickMenuGroup("api")'>
                            <div>
                                <img src="/static/images/redisign/icons-left-menu/icon-code.png" alt="menu icon" style="width: 24px; margin-right: 12px;">{{$t("Developers")}}
                            </div> 
                        </button>
                        <div v-show='tab == "api"'>
                            <div style="padding: 8px 0;background: #333335;">
                                <a class='menu-item' href='/lk/integration' data-href='/lk/integration'>{{$t("Integration")}}</a>
                                <a class='menu-item' href='/lk/open-api' data-href='/lk/open-api'>{{$t("Open API")}}</a>
                            </div>  
                        </div>
                    </div>
                    <div class='menu-group'>
                        <button class='menu-header' @click='clickMenuGroup("settings")'>
                            <img src="/static/images/redisign/icons-left-menu/icon-settings.png" alt="menu icon" style="width: 24px; margin-right: 12px;">
                            <span class='flex-expand'>{{$t("Settings")}} </span>
                            <img :src='`/static/images/flags/${normalize(lang)}.svg`' style='width:24px;margin-right: 15px' alt='langauge icon' />
                        </button>
                        <div v-show='tab == "settings"'>
                            <div class="container-settings">
                                <switch-language />
                                <template v-if='data.viewingUser'>
                                    <menu-item style='margin-top:12px' :name="$t('Logout')" @select="logout" icon='/static/images/redisign/icons-left-menu/icon-logout.svg' />
                                    <join-game-block />
                                    <!-- <menu-item :name="$t('JoinGame')" v-if='!enterCode' @select="joinGame" icon='/static/images/icons/join_game.svg' />
                                    <div class="input-group" style='margin-right: 8px;width:250px' v-if='enterCode'>
                                        <span class="input-group-text" id="basic-addon1">{{$t('Code')}}</span>
                                        <input ref='code' v-model='code' maxlength="7" type="text" class="form-control" :placeholder="$t('EnterCode')" />
                                        <button class="btn btn-success" type="button" id="button-addon2" @click='join'>{{$t('Join')}}</button>
                                    </div> -->
                                </template>    
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div>
               
                <template v-if='data.viewingUser'>
                    <!-- <menu-item :name="$t('MyProfile')" @select="profile" icon='/static/images/redisign/icons-left-menu/icon-profile.svg' /> -->
                    <div style='display:flex;margin-bottom:16px;margin-top: 16px;'>
                        <img v-if='data.viewingUser.avatar' :src="data.viewingUser.avatar" alt="User Avatar" data-toggle="dropdown" class="rounded-circle" style="margin-left: 16px; max-height: 24px;max-width: 24px;border: solid 2px white; " onerror="this.src='/static/images/no-avatar.jpg'" /> 
                        <img v-else src="/static/images/no-avatar.jpg" alt="User Avatar" data-toggle="dropdown" class="rounded-circle" style="margin-left: 16px; max-height: 24px; max-width: 24px" />
                        <span style='margin-left:12px;width: 186px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis'>
                            <a class='authorize' href='/profile' target="_blank" data-href='/profile' style="text-decoration: none;color: white;font-weight: 600;">{{data.viewingUser.visualName}}</a>
                        </span>
                    </div>
                    <!-- <menu-item :name="$t('Logout')" @select="logout" icon='/static/images/redisign/icons-left-menu/icon-logout.svg' /> -->
                </template>
                <template v-if='!data.viewingUser'>
                    <div class="not-authorize" style="display: flex; flex-direction: row; align-items: flex-start;">
                        <img src="/static/images/redisign/icons-left-menu/icon-login.png" alt="menu icon" style="width: 24px; margin-left: 16px;">
                        <menu-item :name="$t('Login')" class='authorize' href='#' data-href='#' :navigate="true" style="position: relative;top: 2px;" />    
                    </div>
                    
                </template>
            </div>
            <!-- <small class='madein'>Сделано в России</small> -->
        </ul>
    </div>
    <div id='mainMenuButton'>
        <div id="openMenuButton" :class="{expanded:show_menu, collapsed: !show_menu}">
            <div v-if='show_menu' class="logo">
                <a href='/' data-href='/'>
                    <img alt='logo' width='74' height='47' src="/static/images/redisign/icons-left-menu/logo-left-menu.svg" />
                </a>
            </div>
            <div v-if='!show_menu' class="logo-short" @click='$emit("show_menu")'>
                <a href='#' data-href='#' @click.prevent="">
                    <!-- <img alt='logo' width='25' height='47' src="/static/images/redisign/icons-left-menu/logo-left-menu-short.svg" /> -->
                    <div class='burger'>
                        <span class="burger_line burger_line_first"></span>
                        <span class="burger_line burger_line_second"></span>
                        <span class="burger_line burger_line_fourth"></span>
                    </div>   
                </a>
            </div>
             <div v-if='show_menu' class='burger_close' @click='$emit("close_menu")'>
                <span class="burger_line burger_line_second"></span>
                <span class="burger_line burger_line_third"></span>
            </div>
           <!-- <div v-else class='burger' @click='$emit("show_menu")'>
                <span class="burger_line burger_line_first"></span>
                <span class="burger_line burger_line_second"></span>
                <span class="burger_line burger_line_fourth"></span>
            </div>                 -->
        </div>
    </div>    
</template>

<script>
import SwitchLanguage from '@root/components/switch-language.vue';
import i18n from '@root/components/i18n';
import MenuItem from './menu_item.vue';
import Api from '@root/components/api';
import Avatar from '@root/components/avatar_with_skills.vue';
import JoinGameBlock from '@root/course/join_game_block.vue';

const pathGroups = {
    "/catalog/skillsets": "catalog",
    "/catalog/courses": "catalog",
    "/catalog/challenges": "catalog",
    "/catalog/tasks": "catalog",
    "/catalog/lists": "catalog",
    "/catalog/cardlists": "catalog",

    "/lk/coursesIStudy": "imstudy",
    "/lk/userCardLists": "imstudy",
    "/profile": "imstudy",

    "/lk/mySkillsets": "my-content",
    "/lk/cardLists": "my-content",
    "/lk/myCourses": "my-content",
    "/lk/myGames": "my-content",
    "/lk/myTasks": "my-content",
    "/lk/new-deck": "my-content",
    "/lk/fieldSets": "my-content",
    "/lk/cardTemplates": "my-content",
    "/lk/cards": "my-content",

    "/lk/howToPlay": "for-game-authors",
    "/lk/playWithFriends": "for-game-authors",
    "/lk/howToOrganize": "for-game-authors",    
    "/lk/teamPlay": "for-game-authors",
    "/lk/createGame": "for-game-authors",
    "/lk/createTask": "for-game-authors",

    "/lk/orderActivity": "about-events",
    "/lk/activityExamples": "about-events",

    "/lk/open-api": "api",
    "/lk/integration": "api",

    "/lk/create-new/challenge": "create-new",
    //"/lk/create-new/template-challenge": "create-new",
    "/lk/create-new/task": "create-new",
    "/lk/create-new/deck": "create-new",
    "/lk/create-new/course": "create-new",
    //"/lk/create-new/ai-challenge": "create-new",

};

function removeLanguagePrefix(path) {
    if (path.length>4 && path[3] === '/' && path.indexOf("/lk/") !== 0) {
        return path.substring(3);
    }
    return path;
}

const pathname = removeLanguagePrefix(document.location.pathname);
const defaultTab = pathGroups[pathname] ?? '';
console.log("Default tab", defaultTab, pathname);


export default { 
    data: function() { 
        return {
            code: '',
            enterCode: false,
            tab: defaultTab,
        }        
    },
    props: ["data", "show_menu"],
    emits: ["show_menu", "close_menu"],
    components: {
        SwitchLanguage, MenuItem, Avatar,
        JoinGameBlock,
    },
    mixins: [i18n],
    computed: {
    },
    created: function () {
    },
    mounted() {
        this.$nextTick(()=>{
            let as = document.querySelectorAll("a");
            as.forEach(a => {
                if (a.dataset.href === pathname) {
                    a.classList.add("router-link-exact-active");
                }
            });
        });
    },
    methods: {
        // todo: code duplicate with switch-langauge.vue
        normalize(lang) {
            if (lang == 'en') 
                return 'gb';
            return lang;
        },        
        profile() {
            document.location = '/profile';
        },
        expand() {
            if (!this.show_menu) {
                this.$emit("show_menu");
            }
        },
        clickMenuGroup(name) {
            if (this.tab === name) {
                this.tab = '';
            } else {
                this.tab = name;
            }
        },        
        async logout() {
            await Api.logout();
            document.location.reload();
        },
        joinGame() {
            this.enterCode = true;
            this.$nextTick(()=>{
                this.$refs.code.focus();
            });
        },
        join() {
            const regex = /(\d{3})-?(\d{3})/;
            const parts = regex.exec(this.code);
            if (parts.length > 2) {
                const code = parts[1] + "-" + parts[2];
                document.location = "/join/" + code;
            }
        },
    }
}
</script>

<i18n>
{
    en: {
        MyProfile: "My profile",
        Logout: "Logout",
        JoinGame: "Join challenge",
        EnterCode: "000-000",
        "about-events": "About events",
        "for-game-authors": "For game creators",
        "createTask": "Create game",
        "createGame": "Create challenge",
        "teamPlay": "Team challenge",
        "activityExamples": "Archive of events",
        "orderActivity": "Order an event",
        "howToOrganize": "How to organize",
        "playWithFriends": "Play with AI and friends",
        "howToPlay": "How to play",
    },
    ru: {
        "createTask": "Как создать задание",
        "createGame": "Как создать игру",
        "teamPlay": "Командная игра",
        "activityExamples": "Архив мероприятий",
        "orderActivity": "Заказать у нас",
        "howToOrganize": "Как организовывать",
        "playWithFriends": "Играть с ИИ/друзьями",
        "howToPlay": "Как играть",
        "about-events": "Мероприятия",
        "for-game-authors": "Авторам игр",
        "Integration": "Интеграция",
        "Developers": "Разработчикам",
        MyProfile: "Мой профиль",
        Logout: "Выйти",
        JoinGame: "Присоединиться к игре",
        Code: "Код",
        EnterCode: "000-000",
        Join: "Вперёд",
        "Study decks": "Колоды для повторения",
        "Courses": "Курсы",
        "Skillsets": "Скиллсеты",
        "Games": "Игры",
        "Settings": "Настройки",
        "Catalog": "Каталог",
        "I'm study": "Я учу",
        "My Content": "Мой контент",
        "Courses": "Курсы",
        "Practice": "Практика",
        "Games": "Задания",
        "Challenges": "Игры",
        "My skills": "Мои навыки",
        "Open API": "Открытое API",
        "Create": "Создать",
        "Game": "Игру",
        "Game from template": "Игру из шаблона",
        "Task": "Задание",
        "Card deck": "Колоду карточек",
        "Course": "Курс",
        "Generate game": "Генерировать игру с ИИ",
        "Login":"Войти",
    }
}
</i18n>

<style lang="scss">
    @import '@root/responsive';

    #mainMenuButton {
        position: fixed;
        top: 0;
        z-index: 9995;

        #openMenuButton {
            width: calc(270px - 16px);
            max-width: 100vw;
            //padding-left: 16px;
            //padding-top: 18px;
            display: flex;
            flex-direction: row;
            align-items: center;

            &.collapsed {
                width: 56px;
                overflow: hidden;
            } 
            &.expanded {
                background: #6179e0;
            }           
        }

        .logo {
            flex: 1 1;
            margin: 12px 12px;
            img {
                height: 47px;
            }   
        }
        .logo-short {
            a {
                height: 46px;
                width: 56px;
                display: flex;
                justify-content: center;
                align-items: center;    
            }   
        }
    }

    .madein {
        color: white;
        font-size: 0.6em;
        margin-left: 70px;
    }

    .site-menu {
        display: block;
        top: 0px;
        left: 0px;  
        background: #6179e0;        
        width: 56px;
        height: 100%;
        transition: all .2s;
        position: relative;
        overflow-x: hidden;
        overflow-y: auto;

        .standard-menu {
            transition: opacity .2s;
        }
  
        .navigationx {
            list-style-type: none;
            padding-left: 0;
            margin-bottom: 0;
             //верхнее дополнительное меню
            .nav-item {            
                min-height: 26px;
                vertical-align: middle;
                //margin-bottom: 7px;
                padding: 4px 0;
                line-height: 1.2;
                &:hover {
                    opacity: 0.8;
                    background: rgba(255, 255, 255, 0.1);
                }

                .icon-menu-left {
                    margin-right: 16px;
                }

                .name-li {
                    margin-left: 28px;
                    font-weight: 500;
                }   
                a {
                    text-decoration: none;
                    color: white;
                    img {
                        opacity: 0.5;
                    }
                }
                &.level2 {
                    margin-bottom: 7px;
                    .name-li {
                        font-size: 0.8em;
                        line-height: 1;
                        font-weight: normal;
                        margin-bottom: 0px;
                    }                          
                }
            }
            .switcher-l2 {
                min-width: 184px;
            }
        }        
        &.expanded {
            width: 270px;
            display: block;
            .logo {
            }
            .logo-short {
            }            
            .navigationx {
                .nav-item {
                    .icon-menu-left {
                        margin-right: 0;
                    }                
                    .name-li {
                        width: 200px;
                        height: auto;
                    } 
                }
            }
            .switcher-l2 {
            }
        }    

        &.collapsed {
            height: 45px;
            border-radius: 0px 0px 8px 0px;            
            cursor: pointer;
            position: fixed;
            overflow: hidden;
            filter: drop-shadow(2px 2px 5px gray);
            opacity: 0.5;

            .name-li {
                opacity: 0;
                transition: 0.2s;
            }
            .madein {
                visibility: hidden;
            }
            .navigationx {
                pointer-events: none;
            }
            .standard-menu {
                opacity: 0;
            }            
        }
    }    

    .burger_close {
        width: 24px;
        height: 16px;
        cursor: pointer;
        position: relative;
        transform: rotate(0deg);
        margin-right: 8px;

        .burger_line {
            display: block;
            width: 100%;
            height: 2px;
            background-color: white;
            position: absolute;
            left: 0;
        }
        .burger_line_second {
            top: 50%;
            transform: translateY(-50%) rotate(45deg);
        }
        .burger_line_third {
            top: 50%;
            transform: translateY(-50%) rotate(-45deg);
        }
    } 
    .burger {
        width: 24px;
        height: 16px;
        cursor: pointer;
        position: relative;

        .burger_line {
            display: block;
            width: 100%;
            height: 2px;
            background-color: white;
            position: absolute;
            left: 0;
            transition: .3s all linear;
        }
        .burger_line_first {
            top: 0;
        }
        .burger_line_second {
            top: 50%;
            transform: translateY(-50%);
        }
        .burger_line_first {
            top: 0;
        }
        .burger_line_fourth {
            width: 80%;
            bottom: 0;
        }
        .burger_active .burger_line_second {
            transform: translateY(-50%) rotate(45deg);
        }
    }

    .menu-group {
        display: flex;
        flex-direction: column;
    }

    .menu-header {
        padding: 16px 8px;
        display: flex;
        flex-direction: row;
        color: white;
        text-align: left;
        width: 100%;
        background: #6179e0;
        border: none;
        outline: none;
        font-weight: 500;
        border-bottom: solid 1px rgba(255, 255, 255, 0.2);
        padding-left: 16px;

        &:hover {
            //background: #666;
            //color: deeppink;
            opacity: 0.8;
            background: #556AC6;
        }
    }


    .menu-item {    
        padding: 8px 4px 8px 24px;
        display: flex;
        flex-direction: row;
        color: white;
        text-decoration: none;
        border-left: solid 6px transparent;
        //background: #333335;

        &.router-link-active {
            //background: #575757;
            color: white;
        }
        &.router-link-exact-active {
            //background: deeppink;
            //color: pink;
            border-left: solid 6px #6179e0;
        }

        &:hover {
            //background: #6179e0;
            color: white;
            opacity: 0.8;
            background: rgba(255, 255, 255, 0.1);
        }
    }

    .custom-menu {
        //a {background: #6179e0;}
        gap: 8px;
        display: flex;
        flex-direction: column;
        font-weight: 500 !important;
        .nav-item {
            margin-bottom: 0;
        }
        &:empty+hr {
            display: none;
        }
    }

    .labelDue {
        align-self: center;
        margin-left: 4px;
        position: relative;
        bottom: 4px;
    }
    .container-settings {
        background: #333335;
        padding: 8px 0;
        .container-switcher2 {
            margin-top: 0!important;
            margin-left: 0!important;
            padding-top: 8px;
            padding-bottom: 8px;
            padding-left: 16px;

            &:hover {
                //background: #6179e0;
                color: white;
                opacity: 0.8;
                background: rgba(255, 255, 255, 0.1);
            }
        }
        .nav-item {
            margin-top: 0!important;
            margin-bottom: 0!important;
            padding-top: 8px;
            padding-bottom: 8px;
            &:hover {
                //background: #6179e0;
                color: white;
                opacity: 0.8;
                background: rgba(255, 255, 255, 0.1);
            }
        }
    }

    .not-authorize {
        .authorize {
            padding-left: 12px!important;
            .name-li {
                margin-left: 0!important;
            }
        }
    }

</style>